import {Component, Input} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {SharedModule} from '../../../shared/shared.module';
import {LocalizedDatePipe} from '../../../shared/pipes/localized-date.pipe';

@Component({
    selector: 'nbd-event-day-month-component',
    templateUrl: './event-day-month-component.component.html',
    imports: [
        SharedModule,
        LocalizedDatePipe
    ],
    styleUrls: ['./event-day-month-component.component.scss']
})
export class EventDayMonthComponentComponent {
  @Input() eventDate?: string;
  protected readonly environment = environment;

  /** The parsed eventDate, or null when it is absent or unparseable. Gating the
   *  template on this avoids feeding an Invalid Date to DatePipe (NG02100). */
  protected get parsedDate(): Date | null {
    if (!this.eventDate) {
      return null;
    }
    const date = new Date(this.eventDate.toString());
    return Number.isNaN(date.getTime()) ? null : date;
  }
}
